<div class="assigned-channel-wrapper" [style.padding]="removePadding ? '12px 0px' : '12px'">
    <div class="assigned-channel-container">
        <div class="channel-name-container">
            <div>{{ assignedChannel.opsData.tag }}</div>
            <div class="text-overflow">{{ assignedChannel.opsData.name }}</div>
        </div>
        <div class="text-overflow">{{ assignedChannel.group.displayName }}</div>
        <div class="text-overflow">
            {{ assignedChannel.group.channelCategory.category }}
        </div>
        <div class="change-channel" (click)="openChannelSelector()">
            {{ 'mimic.settings.system-integration.button.change' | translate }}
        </div>
    </div>
    <div class="remove-button">
        <div (click)="removeAssignedChannel()" style="cursor: pointer">
            {{ 'mimic.settings.system-integration.button.remove' | translate }}
        </div>
    </div>
</div>
